import _objectSpread from "/home/deploy/dash/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { SDK_VERSION, init as init$1 } from '@sentry/browser';
/**
 * Inits the React SDK
 */

function init(options) {
  var opts = _objectSpread({
    _metadata: {}
  }, options);

  opts._metadata.sdk = opts._metadata.sdk || {
    name: 'sentry.javascript.react',
    packages: [{
      name: 'npm:@sentry/react',
      version: SDK_VERSION
    }],
    version: SDK_VERSION
  };
  init$1(opts);
}

export { init };